import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Verification from './pages/Verification';
import TokenRedirect from './pages/TokenRedirect';
import { isAuthenticated } from './utils/auth';

// JWT-based Protected Route component
const ProtectedRoute = ({ element }: { element: React.ReactElement }) => {
  return isAuthenticated() ? element : <Navigate to="/" replace />;
};

// JWT-based Verification Route component
const VerificationRoute = ({ element }: { element: React.ReactElement }) => {
  return isAuthenticated() ? element : <Navigate to="/" replace />;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Main verification route - requires authentication */}
        <Route path="/verification" element={<ProtectedRoute element={<Verification />} />} />
        
        {/* Default route redirects to verification if authenticated */}
        <Route path="/" element={isAuthenticated() ? <Navigate to="/verification" /> : <div className="p-10">Please use a valid verification link with a token</div>} />
        
        {/* Token processing route - this will handle JWT tokens in URL path */}
        <Route path="/:token" element={<TokenRedirect />} />
      </Routes>
    </Router>
  );
}

export default App;